export default __webpack_public_path__ + "static/media/icon-home.d93513f2.svg";